<template>
    <!-- <div> -->
    <!-- Menu -->
    <aside class="layout-menu-horizontal menu-horizontal menu bg-menu-theme flex-grow-0">
        <div class="container-xxl d-flex h-100">
            <a href="#" class="menu-horizontal-prev d-none"></a>
            <div class="menu-horizontal-wrapper">
                <ul class="menu-inner">
                    <!-- Dashboards -->
                    <li  :class="this.$route.name == 'dashboard' ? 'menu-item active' : 'menu-item' ">
                        <router-link to="/dashboard" class="menu-link">
                            <i class="menu-icon tf-icons mdi mdi-home"></i>
                            <div data-i18n="Dashboards">Tableau de bord</div>
                        </router-link>
                    </li>

                    <!-- Bandes -->
                    <li v-if="false" :class=" {'active': this.$route.name == 'prospects', 'menu-item' : true, }">
                        <router-link to="/prospects" class="menu-link">
                            <span class="menu-icon mdi mdi-file"></span>
                            <div data-i18n="Dashboards">Prospects</div>
                        </router-link>
                    </li>
                        <li :class="{'active': this.$route.name === 'prospects', 'menu-item' : true, 'open' : open_aliment}" @mouseover="open_aliment=true" @mouseleave="open_aliment=false">
                                    <a href="javascript:void(0)" class="menu-link menu-toggle">
                                        <span class="menu-icon mdi mdi-file"></span>
                                        <div data-i18n="Dashboards">Prospects</div>
                                    </a>
                                    <ul class="menu-sub">
                                        <li  :class=" {'active': this.$route.name === 'prospects', 'menu-item' : true, }">
                                            <router-link to="/prospects" class="menu-link">
                                                <span class="menu-icon mdi mdi-file"></span>
                                                <div data-i18n="Dashboards">Fiche Prospects</div>
                                            </router-link>
                                        </li>
                                        <li class="menu-item">
                                            <a href="javascript:void(0)"  class="menu-link">
                                                <span class="menu-icon mdi mdi-calendar-range"></span>
                                            <div data-i18n="Without menu">Programme d'activité</div>
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                <li  class="menu-item">
                                    <router-link to="/dashboard" class="menu-link">
                                        <span class="menu-icon mdi mdi-file"></span>
                                        <div data-i18n="Dashboards">Appel d'offre</div>
                                    </router-link>
                                </li>

                        <!-- Pondeuses -->
                                <li v-if="user.profil=='administrateur'" @mouseover="open_pondeuse=true" @mouseleave="open_pondeuse=false" :class="{'active': this.$route.name === 'utilisateurs' || this.$route.name === 'secteurs' || this.$route.name === 'garanties' || this.$route.name === 'prospections', 'menu-item' : true, 'open' : open_pondeuse}">
                                    <a class="menu-link menu-toggle">
                                        <span class="menu-icon mdi mdi-cog"></span>
                                        <div data-i18n="Dashboards">Paramètres</div>
                                    </a>
                                    <ul class="menu-sub">
                                        <li :class="this.$route.name == 'utilisateurs' ? 'menu-item active' : 'menu-item'">
                                            <router-link to="/utilisateurs" class="menu-link">
                                                <span class="menu-icon mdi mdi-account"></span>
                                                <div data-i18n="Without menu">Utilisateurs</div>
                                            </router-link>
                                        </li>
                                        
                                        <li :class="this.$route.name == 'garanties' ? 'menu-item active' : 'menu-item'">
                                            <router-link to="/garanties" class="menu-link">
                                                <span class="mdi mdi-format-list-bulleted menu-icon"></span>
                                                <div data-i18n="Without menu">Garanties</div>
                                            </router-link>
                                        </li>
                                        <li :class="this.$route.name == 'secteurs' ? 'menu-item active' : 'menu-item'">
                                            <router-link to="/secteurs" class="menu-link">
                                                <span class="mdi mdi-format-list-bulleted menu-icon"></span>
                                                <div data-i18n="Without menu">Secteurs</div>
                                            </router-link>
                                        </li>
                                        <li :class="this.$route.name == 'prospections' ? 'menu-item active' : 'menu-item'">
                                            <router-link to="/prospections" class="menu-link">
                                                <span class="mdi mdi-format-list-bulleted menu-icon"></span>
                                                <div data-i18n="Without menu">Natures prospections</div>
                                            </router-link>
                                        </li>
                                        
                                    </ul>
                                </li>

                    
                    
                    
            
                    
                </ul>
            </div>
            <a href="#" class="menu-horizontal-prev d-none"></a>
        </div>
    </aside>
    <!-- / Menu -->
    <!-- </div> -->
</template>
  
<script>
    
    // import { menu } from "@/assets/js/menu.js"; 
    // import { helpers } from "@/assets/js/helpers.js"; 
    // import { main } from "@/assets/js/main.js"; 
    export default {
        name: 'MenuItem',
        props: {
            msg: String
        },
        data() {
            return {
                open_bande : false,
                open_pondeuse : false,
                open_aliment : false,
                open_medicament : false,
                user : {}
            }
        },
        mounted(){
            this.user = {...this.$store.state.user}
            console.log(this.user);
        },
    }
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>
  